import styled from "styled-components";
import useDevice from "@/hooks/useDevice";
import {DEVICE_TYPES, ICONS, LOCALES, WHO_HELPS_VARIANTS} from "@/constants";
import {BREAKPOINTS} from "@/styles/themeSettings";
import TeamMembersCard from "@/components/TilesModule/variants/WhoHelpsTilesModule/TeamMembersCard";
import {getCssSizeValue} from "@/utils/utils";
import {useRouter} from "next/router";
import Icon from "@/components/common/Icon/Icon";

const Wrapper = styled.div`
    position: relative;

    &.variant-${WHO_HELPS_VARIANTS.MANY} {
        margin-bottom: ${getCssSizeValue(100)};
    }
`

const SloganWrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100% + 59%);
	
	&.short {
		width: 100%;
	}
`

const CONTAINER_SIZES = {
	[BREAKPOINTS.DESKTOP]: {
		[WHO_HELPS_VARIANTS.DEFAULT]: 5,
		[WHO_HELPS_VARIANTS.TWO_TEAM_MEMBERS]: 7,
		[WHO_HELPS_VARIANTS.MANY]: 12
	},
	[BREAKPOINTS.TABLET]: {
		[WHO_HELPS_VARIANTS.DEFAULT]: 5,
		[WHO_HELPS_VARIANTS.TWO_TEAM_MEMBERS]: 7,
		[WHO_HELPS_VARIANTS.MANY]: 12
	},
	[BREAKPOINTS.MOBILE]: {
		[WHO_HELPS_VARIANTS.DEFAULT]: 8,
		[WHO_HELPS_VARIANTS.TWO_TEAM_MEMBERS]: 8,
		[WHO_HELPS_VARIANTS.MANY]: 8
	}
}


const Slogan = styled.div`
    width: auto;
    display: flex;
    align-items: flex-end;

    .icon {
        height: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};

        @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
            height: ${getCssSizeValue(52, BREAKPOINTS.TABLET)};
        }

        @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
            width: 100%;
            height: initial;
        }

        svg {
            width: unset !important;

            @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
                width: 100% !important;
            }

            path {
                fill: ${props => props.theme.colors.richBlack};
            }
            polygon {
                fill: ${props => props.theme.colors.chilliRed};

                &.white {
                    fill: ${props => props.theme.colors.richBlack} !important;
                }
            }
        }
    }
`

function groupTeamMembersData(teamMembers) {
	const images = [];
	const restInfo = [];

	teamMembers.forEach((member) => {
		const {verticalImage, ...info} = member;
		images.push(verticalImage);
		restInfo.push(info);
	});

	return {images, restInfo};
}

function getIconNameBasedOnLocale(locale) {
	switch (locale) {
		case LOCALES.PL:
			return ICONS.FOOTER_SLOGAN_PL
		case LOCALES.EN:
			return ICONS.FOOTER_SLOGAN_EN
		default:
			return ICONS.FOOTER_SLOGAN_PL
	}
}

export default function TeamMembersContainer({teamMembers, teamMemberTitle, variant, memberIcon, partners}) {
	const {locale} = useRouter()
	const {isDesktop, isTablet} = useDevice()
	const deviceType = isDesktop ? DEVICE_TYPES.DESKTOP : isTablet ? DEVICE_TYPES.TABLET : DEVICE_TYPES.MOBILE
	const colSize = CONTAINER_SIZES[deviceType][variant]
	const groupedData = groupTeamMembersData(teamMembers)
	const displaySlogan = variant === WHO_HELPS_VARIANTS.TWO_TEAM_MEMBERS && partners.length > 2
	const iconName = getIconNameBasedOnLocale(locale)
	const isEvenPartnersAmount = partners.length % 2 === 0

	return (
		<Wrapper className={`col-desktop-${colSize} col-tablet-${colSize} col-mobile-${colSize} variant-${variant}`}>
			<TeamMembersCard
				data={groupedData}
				teamMemberTitle={teamMemberTitle}
				variant={variant}
				memberIcon={memberIcon}
			/>
			{displaySlogan && (
				<SloganWrapper className={`${isEvenPartnersAmount ? 'short' : ''}`}>
					<Slogan>
						<Icon name={iconName} className='no-color' />
					</Slogan>
				</SloganWrapper>
			)}
		</Wrapper>
	)
}